module.exports = __webpack_public_path__ + "static/testimonial-pic-2-a1af50dd36a63a3e3bb3b4c114c8d041.jpg";